import React, { useContext } from 'react';
import { ThemeProvider } from 'emotion-theming';
import { Theme, ThemeContext } from '@ordermentum/ui-shared/utilities/theme';
import {
  ColorCodes,
  colorsForTheme,
} from '@ordermentum/ui-shared/foundations/color';
import { EXTERNAL_LINKS } from '@ordermentum/ui-constants';
import { Container, Text, TextLink } from './Policies.styles';

type themeStyles = {
  textLinkColor: ColorCodes;
};

const getTheme = (theme: Theme): themeStyles => {
  const colors = colorsForTheme(theme);
  const colorThemes = {
    textLinkColor: colors.SWEET_ORANGE,
  };
  return colorThemes;
};

const Policies = () => {
  const currentTheme = getTheme(useContext(ThemeContext));
  return (
    <ThemeProvider theme={currentTheme}>
      <Container>
        <Text>
          By creating an account you agree and consent to our{' '}
          <TextLink
            data-testid="terms-and-conditions-link"
            href={EXTERNAL_LINKS.LEGAL.TERMS_CONDITIONS}
            target="_blank"
            rel="noopener noreferrer"
          >
            Terms and Conditions
          </TextLink>
          ,{' '}
          <TextLink
            data-testid="privacy-collection-link"
            href={EXTERNAL_LINKS.LEGAL.PRIVACY_COLLECTION_NOTICE}
            target="_blank"
            rel="noopener noreferrer"
          >
            Privacy Collection Notice
          </TextLink>{' '}
          and{' '}
          <TextLink
            data-testid="privacy-policy-link"
            href={EXTERNAL_LINKS.LEGAL.PRIVACY_POLICY}
            target="_blank"
            rel="noopener noreferrer"
          >
            Privacy Policy
          </TextLink>
        </Text>
      </Container>
    </ThemeProvider>
  );
};

export default Policies;
